import React, {ChangeEvent, FC, FormEvent, useEffect, useState} from "react";
import Breadcrumb from "../../components/common/Breadcrumbs";
import Form from "../../components/common/form/Form";
import {useNavigate} from "react-router-dom";
import {OptionType} from "../../helpers/utils/StyleUtils";
import InputField from "../../components/common/form/InputField";
import {createOptionListForSelectTag} from "../../helpers/utils/Utils";
import SelectField from "../../components/common/form/SelectField";
import {useGetEnumsQuery} from "../../app/globalApi";
import {useGetAllTenantsQuery} from "./tenantApi";
import {
    useCreateCustomerMutation,
    useLazyGetCustomerByTenantAndLevelQuery
} from "./customerApi";
import {handleRTKQuery} from "../../helpers/utils/RtkQueryUtils";
import {Routes as AppRoutes} from "../../routes";
import ButtonTray from "../../components/common/form/ButtonTray";

const CreateCustomerForm: FC = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "Customers", url: "/customers"},
        {content: "Add Customer", url: "/customers/create"},
    ]);

    const navigate = useNavigate();
    const [customerData, setCustomerData] = useState<any>({
        'customerLevel': {value: 'TENANT', label: 'Tenant'}
    });
    const {data: enums} = useGetEnumsQuery("");
    const tenantList = useGetAllTenantsQuery("");
    const [createCustomer, createCustomerApiResponse] = useCreateCustomerMutation();
    const [customersData, setCustomersData] = useState([]);
    const [getCustomerByTenantAndLevel, {data: fetchedCustomers}] = useLazyGetCustomerByTenantAndLevelQuery();


    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        let obj = {
            customerName: customerData.customerName,
            customerType: customerData.customerType?.value || 'RETAIL',
            customerLevel: customerData.customerLevel?.value,
            billingType: customerData.billingType?.value || 'PERCLOSE',
            tenant: customerData?.customerLevel?.value !== "TENANT" ? customerData.tenant?.value : customerData.tenant,
            contactStrategy: ['CUSTOMER'],
            requireMfa: customerData?.requireMfa,
            fulfillmentCustomer: customerData?.fulfillmentCustomer ?? false,
            fulfillmentCandidates: customerData?.fulfillmentCandidates?.map((el: any) => ({
                id: el.value
            })),
            branches: [{
                preferredState: 'TX', preferredVendor: 'TGX', deliveryBlacklist: []
            }],
            pdfHeaderOption: (customerData.customerType?.value === 'WHOLESALE') ? 'TITLE' : null,
            pdfHeaderTitle: (customerData.customerType?.value === 'WHOLESALE') ? customerData.customerName : '',
            remitName: (customerData.customerType?.value === 'WHOLESALE') ? customerData.customerName : '',
            enabled: true,
        }

        await handleRTKQuery(
            async () => {
                return await createCustomer(obj).unwrap();
            },
            (response: any) => {
                if (response.success) {
                    setCustomerData({});
                    navigate("/customers");
                }

            }
        );
    }


    useEffect(() => {
        const tenantId = customerData?.tenant?.value || customerData?.tenant;
        const customerLevel = customerData?.customerLevel.value;
        if (tenantId && customerLevel) {
            getCustomerByTenantAndLevel({tenantName: tenantId, level: customerLevel});
        }
    }, [customerData?.tenant, customerData?.customerLevel, getCustomerByTenantAndLevel]);

    useEffect(() => {
        if (fetchedCustomers) {
            setCustomersData(fetchedCustomers);
        }
    }, [fetchedCustomers]);

    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null }) => {
        const {name, value} = "target" in e ? e.target : e;
        setCustomerData({
            ...customerData,
            [name]: value,
        })


    }
    const handleToggle = (property: string) => () => {
        setCustomerData((prevData: any) => ({
            ...prevData,
            [property]: !prevData[property]
        }));
    };


    useEffect(() => {

        let val = customerData?.customerLevel?.value;
        if (val === "TENANT") {
            setCustomerData({
                ...customerData,
                tenantId: null
            })
        }

    }, [customerData?.customerLevel]);

    return (
        <>

            <div className="adduser_container px-4 py-2">

                <Breadcrumb crumbs={crumbs}/>
                <div className="flex justify-center mt-3">
                    <div className="bg-text-0 lg:w-4/6 sm:w-full p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                        <h3 className="text-xl font-semibold text-surface-0 pb-3 border-b border-surface-7">Add
                            Customer</h3>

                        <Form onSubmit={handleSubmit} fields={<>

                            <div className="grid grid-cols-12 adduser_Wrapper">
                                <InputField
                                    name={"customerName"}
                                    label="Customer Name"
                                    onChange={handleOnChange}
                                    value={customerData?.customerName || ""}
                                    type="text"
                                    placeholder="Enter Customer Name..."
                                    required={true}
                                />


                                <SelectField
                                    placeholder='Select Customer Level...'
                                    value={customerData?.customerLevel || null}
                                    options={createOptionListForSelectTag(enums?.["CustomerLevel"]?.filter((cur: any) => {
                                        return cur.constant !== "SYS"
                                    }), "value", "constant")}
                                    onChange={(selectedOption) => {
                                        handleOnChange({name: "customerLevel", value: selectedOption})
                                    }}
                                    required={true}
                                    label={"Customer Level"}
                                />

                                {customerData?.customerLevel &&
                                    <>
                                        {
                                            customerData?.customerLevel?.value !== "TENANT" ?
                                                <SelectField
                                                    placeholder='Select Tenant...'
                                                    value={customerData?.tenant || null}
                                                    options={createOptionListForSelectTag(tenantList?.data, "name", "name")}
                                                    onChange={(selectedOption) => {
                                                        handleOnChange({name: "tenant", value: selectedOption})
                                                    }}
                                                    required={true}
                                                    label={"Tenant"}
                                                />
                                                :
                                                <InputField
                                                    name={"tenant"}
                                                    label="Tenant Name"
                                                    onChange={handleOnChange}
                                                    value={customerData?.tenant}
                                                    type="text"
                                                    placeholder="Enter Tenant..."
                                                    required={true}
                                                />
                                        }

                                    </>
                                }

                                {customerData?.customerLevel && customerData.customerLevel.value !== "TENANT" &&
                                    <>
                                        <SelectField
                                            placeholder='Select Customer Type...'
                                            value={customerData?.customerType || null}
                                            options={createOptionListForSelectTag(enums?.["CustomerType"], "value", "constant")}
                                            onChange={(selectedOption) => {
                                                handleOnChange({name: "customerType", value: selectedOption})
                                            }}
                                            required={true}
                                            label={"Customer Type"}
                                        />

                                        <SelectField
                                            placeholder='Select Billing Type...'
                                            value={customerData?.billingType || null}
                                            options={createOptionListForSelectTag(enums?.["BillingType"], "value", "constant")}
                                            onChange={(selectedOption) => {
                                                handleOnChange({name: "billingType", value: selectedOption})
                                            }}
                                            required={true}
                                            label={"Billing Type"}
                                        />

                                        <InputField
                                            name={"fulfillmentCustomer"}
                                            label="Fulfillment Customer"
                                            onChange={handleToggle("fulfillmentCustomer")}
                                            checked={customerData?.fulfillmentCustomer || false}
                                            type="checkbox"
                                            className="mt-3"

                                        />
                                    </>
                                }
                                {customerData?.fulfillmentCustomer && (
                                    <>
                                        {/*<SelectField*/}
                                        {/*    placeholder='SelectFulfillment Candidates...'*/}
                                        {/*    value={customerData?.fulfillmentCandidates || null}*/}
                                        {/*    options={createOptionListForSelectTag(customersData, "customerName", "id")}*/}
                                        {/*    onChange={(selectedOption) => {*/}
                                        {/*        handleOnChange({name: "fulfillmentCandidates", value: selectedOption})*/}
                                        {/*    }}*/}
                                        {/*    label={"Fulfillment Candidates"}*/}
                                        {/*    isMulti={true}*/}
                                        {/*/>*/}

                                        <SelectField
                                            placeholder='Select Fulfillment Customer...'
                                            value={
                                                customerData?.fulfillmentCandidates
                                            }
                                            options={createOptionListForSelectTag(
                                                customersData,
                                                "customerName",
                                                "id"
                                            )}
                                            onChange={(selectedOptions) => {
                                                handleOnChange({
                                                    name: "fulfillmentCandidates",
                                                    value: selectedOptions
                                                })
                                            }}
                                            required={true}
                                            label={"Fulfillment Candidates"}
                                            isMulti={true}
                                        />

                                    </>
                                )}

                            </div>

                            <div className="col-span-12 md:grid md:grid-cols-12 gap-3">
                                <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                </div>
                                <div className="relative col-span-9">
                                    <div className={"mt-4 flex"}>
                                        <ButtonTray
                                            buttons={[
                                                {
                                                    buttonProps: {
                                                        btnText: "Cancel",
                                                        onClick: () => navigate(AppRoutes.Customers.path),
                                                        type: "cancel",
                                                    },
                                                    buttonType: "button"
                                                },
                                                {
                                                    buttonProps: {
                                                        btnText: "Submit",
                                                        type: "submit",
                                                        isLoading: (createCustomerApiResponse.isLoading),
                                                    },
                                                    buttonType: "button"
                                                }
                                            ]}
                                            align="end"
                                            gap={2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>}/>
                    </div>
                </div>
            </div>

        </>
    )
}

export default CreateCustomerForm;